module.exports = __webpack_public_path__ + "static/media/cyber.b7c12793.png";